/**
 * Zzzing Admin API
 * Zzzing Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LandOwnerPayeeDetails } from './landOwnerPayeeDetails';
import { LegalDocumentType } from './legalDocumentType';
import { LandOwnerState } from './landOwnerState';
import { Address } from './address';
import { LandOwnerType } from './landOwnerType';
import { LandOwnerContactDetails } from './landOwnerContactDetails';


export interface LandOwner { 
    id?: string;
    friendly_reference?: string;
    type?: LandOwnerType;
    name?: string;
    legal_address?: Address;
    manual_rating?: number;
    legal_document_type?: LegalDocumentType;
    legal_document_reference?: string;
    number_of_linked_contracts?: number;
    number_of_linked_properties?: number;
    contact_details?: LandOwnerContactDetails;
    payee_details?: LandOwnerPayeeDetails;
    custom_notes?: string;
    created_timestamp?: string;
    last_updated?: string;
    state?: LandOwnerState;
}

